import React from 'react';
import LegalLayout from '../components/LegalLayout';
import { 
  HiOutlineBuildingOffice, 
  HiOutlineMapPin, 
  HiOutlineEnvelope, 
  HiOutlinePhone, 
  HiOutlineBriefcase
} from 'react-icons/hi2';

const sections = [
  { id: 'merchant-info', title: '1. Merchant & Entity Details' },
  { id: 'locations', title: '2. Registered & Operational Address' },
  { id: 'direct-contact', title: '3. Direct Email & Phone' },
];

const ContactUs = () => {
  return (
    <LegalLayout
      title="Contact Us"
      subtitle="Have questions about subscriptions, corporate orders, or policy inquiries? We're here to help."
      lastUpdated="October 09, 2026"
      sections={sections}
    >
      <div className="space-y-8 text-gray-700">
        
        {/* Intro Banner */}
        <div className="p-4 rounded-lg bg-orange-50/60 border border-orange-200/60 flex items-start gap-3">
          <HiOutlinePhone className="text-xl text-[#FF410B] shrink-0 mt-0.5" />
          <p className="text-xs sm:text-sm text-gray-700 leading-relaxed font-normal">
            You may contact us using the official entity details below. Our support team is available Monday through Sunday to assist you.
          </p>
        </div>

        {/* Section 1 - Merchant details */}
        <section id="merchant-info" className="scroll-mt-24 space-y-2">
          <h2 className="text-base sm:text-lg font-bold text-gray-900">1. Merchant Legal Entity</h2>
          <div className="p-4 rounded-lg bg-slate-50 border border-slate-200 flex items-center gap-3">
            <div className="p-2.5 rounded-lg bg-white border border-slate-200 text-[#FF410B]">
              <HiOutlineBriefcase className="text-xl" />
            </div>
            <div>
              <span className="text-xs font-semibold text-gray-400 uppercase tracking-wider block">Legal Name</span>
              <h3 className="text-sm font-bold text-gray-900">Feastic Services Pvt Ltd</h3>
              <span className="text-xs text-gray-500 font-normal">Operating under brand name <span className="font-semibold text-[#FF410B]">Falhari</span></span>
            </div>
          </div>
        </section>

        {/* Section 2 - Addresses */}
        <section id="locations" className="scroll-mt-24 space-y-2">
          <h2 className="text-base sm:text-lg font-bold text-gray-900">2. Registered & Operational Addresses</h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
            
            {/* Registered Address */}
            <div className="p-4 rounded-lg bg-white border border-gray-200 space-y-1">
              <div className="flex items-center gap-1.5 text-[#FF410B] font-bold text-xs uppercase">
                <HiOutlineBuildingOffice className="text-base" />
                <span>Registered Address</span>
              </div>
              <p className="text-xs text-gray-700 leading-relaxed">
                603 Tower A, Tarika Apartment, Sector 43, Gurgaon, Haryana - 122001, INDIA
              </p>
            </div>

            {/* Operational Address */}
            <div className="p-4 rounded-lg bg-white border border-gray-200 space-y-1">
              <div className="flex items-center gap-1.5 text-[#FF410B] font-bold text-xs uppercase">
                <HiOutlineMapPin className="text-base" />
                <span>Operational Address</span>
              </div>
              <p className="text-xs text-gray-700 leading-relaxed">
                GF-108H, Sushant Shopping Arcade, Sushant Lok-1, Sector 43, Gurugram - 122002, Haryana, INDIA
              </p>
            </div>

          </div>
        </section>

        {/* Section 3 - Direct Contact */}
        <section id="direct-contact" className="scroll-mt-24 space-y-2">
          <h2 className="text-base sm:text-lg font-bold text-gray-900">3. Direct Support Channels</h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
            
            <a
              href="mailto:hello@falhari.com"
              className="p-4 rounded-lg bg-slate-50 hover:bg-orange-50/70 border border-slate-200 hover:border-orange-200 transition flex items-center gap-3 group"
            >
              <div className="p-2.5 rounded-lg bg-white border border-slate-200 text-[#FF410B] group-hover:bg-[#FF410B] group-hover:text-white transition">
                <HiOutlineEnvelope className="text-lg" />
              </div>
              <div>
                <span className="text-xs font-semibold text-gray-500 uppercase block">Email Us</span>
                <span className="text-xs font-bold text-gray-900 group-hover:text-[#FF410B] transition">
                  hello@falhari.com
                </span>
              </div>
            </a>

            <a
              href="tel:9810387325"
              className="p-4 rounded-lg bg-slate-50 hover:bg-orange-50/70 border border-slate-200 hover:border-orange-200 transition flex items-center gap-3 group"
            >
              <div className="p-2.5 rounded-lg bg-white border border-slate-200 text-[#FF410B] group-hover:bg-[#FF410B] group-hover:text-white transition">
                <HiOutlinePhone className="text-lg" />
              </div>
              <div>
                <span className="text-xs font-semibold text-gray-500 uppercase block">Call Helpline</span>
                <span className="text-xs font-bold text-gray-900 group-hover:text-[#FF410B] transition">
                  +91 9810387325
                </span>
              </div>
            </a>

          </div>
        </section>

      </div>
    </LegalLayout>
  );
};

export default ContactUs;
